import { combineReducers } from '@reduxjs/toolkit'

import { rtkApi } from 'src/Services/rtkApi'

import { artistSpotifyApi } from './artistSpotifyApi'
import { referralBonusApi } from './referralBonusApi'
import { genresProcess } from './genres-process'
import { sidebarProcess } from './sidebar-process'
import { playlistsProcess } from './playlists-process'
import { artistsProcess } from './artists-process'
import { wiseProcess } from './wise-process'
import { spotifyTracksProcess } from './spotifyTracks-process'
import { settingsProcess } from './settings-process'
import { notificationProcess } from './notification-process'
import { sessionNotificationsProcess } from './sessionNotification-process'
import { scheduleProcess } from './schedule-process'
import { authProcess } from './auth-process'
import { alertProcess } from './alert-process'
import { transactions } from './transactions-process/reducer'
import { paymentProcess } from './payment-process'
import { paypalTransactionsProcess } from './paypalTransactions-process'
import { sourceBusterProcess } from './sourcebuster-process'
import { analyticsProcess } from './analytics-process'
import { levelsProcess } from './levels-procces'
import { getPremium } from './getPremiumProcess'
import { referral } from './referral-process'
import { subscriptionsProcess } from './subscription-process'
import { creatorRegister } from './creatorRegister-process'
import { typeformProcess } from './typeform-process'
import { tikTokTrackProcess } from './tiktokTrack-process'
import { checkoutTimer } from './checkoutCountdown-process'
import { firstTrackApi } from './firstTrackApi'
import { spotifyApi } from './spotifyTracksApi'
import { publicSpotifyArtistsApi } from './publicSpotifyArtistsApi'
import { campaignListProcess } from './campaignList-process'
import { googleAnalyticsProcess } from './googleAnalytics-process'
import { campaignsActionsProcess } from './campaignsActions-process'
import { pageLayoutProcess } from './pageLayout-process'
import { canceledCreatorAlerts } from './canceledCreatorAlertsProcess'
import { spotifyCampaignMatchingProcess } from './spotifyCampaignMatchingProcess'
import { themeProcess } from './theme-process'
import { selectedCuratorsReducer } from './selectedCuratorsSlice'

const rootReducer = combineReducers({
  transactions,
  referral,
  [rtkApi.reducerPath]: rtkApi.reducer,
  [artistSpotifyApi.reducerPath]: artistSpotifyApi.reducer,
  [referralBonusApi.reducerPath]: referralBonusApi.reducer,
  [firstTrackApi.reducerPath]: firstTrackApi.reducer,
  [spotifyApi.reducerPath]: spotifyApi.reducer,
  [publicSpotifyArtistsApi.reducerPath]: publicSpotifyArtistsApi.reducer,
  subscriptions: subscriptionsProcess,
  campaignsActions: campaignsActionsProcess.reducer,
  authentication: authProcess,
  campaignList: campaignListProcess.reducer,
  scheduling: scheduleProcess,
  notifications: notificationProcess.reducer,
  sessionNotifications: sessionNotificationsProcess.reducer,
  artists: artistsProcess.reducer,
  spotifyTracks: spotifyTracksProcess.reducer,
  tikTokTrack: tikTokTrackProcess.reducer,
  alerts: alertProcess,
  settings: settingsProcess,
  transferwise: wiseProcess.reducer,
  playlists: playlistsProcess.reducer,
  sidebar: sidebarProcess.reducer,
  layout: pageLayoutProcess.reducer,
  genres: genresProcess.reducer,
  payment: paymentProcess.reducer,
  paypalTransactions: paypalTransactionsProcess.reducer,
  sourcebuster: sourceBusterProcess.reducer,
  analytics: analyticsProcess.reducer,
  getPremium: getPremium.reducer,
  levels: levelsProcess.reducer,
  creatorRegister: creatorRegister.reducer,
  typeform: typeformProcess.reducer,
  checkoutTimer: checkoutTimer.reducer,
  googleAnalytics: googleAnalyticsProcess.reducer,
  canceledCreatorAlerts: canceledCreatorAlerts.reducer,
  spotifyCampaignMatchingProcess: spotifyCampaignMatchingProcess.reducer,
  theme: themeProcess.reducer,
  selectedCurators: selectedCuratorsReducer,
})

export default rootReducer
